import { InstallDocumentTypes } from 'types';

import { documentRendererRegistry } from './DocumentRendererRegistry';
import { ShadeReportRenderer } from './ShadeReportRenderer';

// Register document-specific renderers here
documentRendererRegistry.register(InstallDocumentTypes.shadeReport, ShadeReportRenderer);

export { DocumentRendererFactory } from './DocumentRendererFactory';
export { documentRendererRegistry } from './DocumentRendererRegistry';
export type { DocumentRendererProps } from './DocumentRendererRegistry';
